import React from 'react';

const SvgTimer = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="25"
    viewBox="0 0 21 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.25 14.75C20.25 20.1359 15.8859 24.5 10.5 24.5C5.11406 24.5 0.75 20.1359 0.75 14.75C0.75 9.875 4.32656 5.83437 9 5.11719V3.5H7.6875C7.37813 3.5 7.125 3.24688 7.125 2.9375V1.0625C7.125 0.753125 7.37813 0.5 7.6875 0.5H13.3125C13.6219 0.5 13.875 0.753125 13.875 1.0625V2.9375C13.875 3.24688 13.6219 3.5 13.3125 3.5H12V5.11719C13.7578 5.38906 15.3609 6.12969 16.6734 7.20781L17.9625 5.91875C18.1828 5.69844 18.5391 5.69844 18.7594 5.91875L20.0859 7.24531C20.3062 7.46562 20.3062 7.82187 20.0859 8.04219L18.7078 9.42031L18.6797 9.44844C19.6734 10.9672 20.25 12.7906 20.25 14.75ZM12 16.4375V9.33594C12 9.02656 11.7469 8.77344 11.4375 8.77344H9.5625C9.25313 8.77344 9 9.02656 9 9.33594V16.4375C9 16.7469 9.25313 17 9.5625 17H11.4375C11.7469 17 12 16.7469 12 16.4375Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTimer;
